import { render, staticRenderFns } from "./callInfoComments.vue?vue&type=template&id=3b75648a&scoped=true&"
import script from "./callInfoComments.vue?vue&type=script&lang=js&"
export * from "./callInfoComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75648a",
  null
  
)

export default component.exports